import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9254f046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-detail-card" }
const _hoisted_2 = { class: "patient-detail-card__header" }
const _hoisted_3 = { class: "text-bold" }
const _hoisted_4 = { class: "patient-detail-card__icons" }
const _hoisted_5 = { class: "patient-detail-card__subtitle" }
const _hoisted_6 = { class: "patient-detail-card__info" }
const _hoisted_7 = { class: "patient-detail-card__info-item" }

import { PropType } from 'vue'
import { PatientType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  patientInfo: Object as PropType<PatientType>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.patientInfo.surname) + " " + _toDisplayString(__props.patientInfo.name) + " " + _toDisplayString(__props.patientInfo.patronymic ?? ''), 1),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "open"),
        _renderSlot(_ctx.$slots, "remove")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, "Пациент №" + _toDisplayString(__props.patientInfo.id), 1),
      _createElementVNode("p", null, "№ Медкарты: " + _toDisplayString(__props.patientInfo.cart_number), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.patientInfo.email), 1),
      _createElementVNode("p", null, "Дата рождения: " + _toDisplayString(__props.patientInfo.date), 1)
    ])
  ]))
}
}

})